module.exports = __webpack_public_path__ + "static/media/defaultAvatar3.f09c7391.svg";